const config = {
    user: {
        permission: {
            super: 'super_admin:*', 
            company: 'company_admin:*', 
            event: 'event_admin:*'
        }
    },
    guest: {
        dbColMapping: {
            'Username': 'username',
            'Password': 'password',
            'First Name': 'ev_firstname',
            'Last Name': 'ev_lastname',
            'Full Name': 'ev_fullname',
            'First Name TC': 'ev_firstname_tc',
            'Last Name TC': 'ev_lastname_tc',
            'Full Name TC': 'ev_fullname_tc',
            'First Name SC': 'ev_firstname_sc',
            'Last Name SC': 'ev_lastname_sc',
            'Full Name SC': 'ev_fullname_sc',
            'Profile Pic': 'ev_profile_pic',
            'Employee ID': 'ev_employeeid',
            'Agency ID': 'ev_agencyid',
            'Salutation': 'ev_title',
            'Salutation TC': 'ev_title_tc',
            'Salutation SC': 'ev_title_sc',
            'Email': 'ev_email',
            'Company': 'ev_company',
            'Company TC': 'ev_company_tc',
            'Company SC': 'ev_company_sc',
            'Department': 'ev_department',
            'Department TC': 'ev_department_tc',
            'Department SC': 'ev_department_sc',
            'Position': 'ev_job_title',
            'Position TC': 'ev_job_title_tc',
            'Position SC': 'ev_job_title_sc',
            'Office #': 'ev_office_phone',
            'Country Code': 'ev_country_code',
            'Mobile #': 'ev_mobile',
            'Qrcode': 'ev_token',
            'Remarks': 'ev_remarks',
            'Sms': 'ev_sms',
            'vip(1/0)': 'ev_vip_flag',
            'No reminder(1/0)': 'ev_exclude_email_reminder',
            'Local/Oversea(local/oversea)': 'ev_local_oversea',
            'Private account(yes/no)': 'ev_private_account',
            'Notification(yes/no)': 'ev_notification',
            'Passcode': 'ev_passcode',
        }
    },
    ev_guest: {
        dbColMapping: {
            'First Name': 'ev_firstname',
            'Last Name': 'ev_lastname',
            'Full Name': 'ev_fullname',
            'First Name TC': 'ev_firstname_tc',
            'Last Name TC': 'ev_lastname_tc',
            'Full Name TC': 'ev_fullname_tc',
            'First Name SC': 'ev_firstname_sc',
            'Last Name SC': 'ev_lastname_sc',
            'Full Name SC': 'ev_fullname_sc',
            'Employee ID': 'ev_employeeid',
            'Agency ID': 'ev_agencyid',
            'Salutation': 'ev_title',
            'Salutation TC': 'ev_title_tc',
            'Salutation SC': 'ev_title_sc',
            'Email': 'ev_email',
            'Company': 'ev_company',
            'Company TC': 'ev_company_tc',
            'Company SC': 'ev_company_sc',
            'Department': 'ev_department',
            'Department TC': 'ev_department_tc',
            'Department SC': 'ev_department_sc',
            'Position': 'ev_job_title',
            'Position TC': 'ev_job_title_tc',
            'Position SC': 'ev_job_title_sc',
            'Office #': 'ev_office_phone',
            'Country Code': 'ev_country_code',
            'Mobile #': 'ev_mobile',
            'Qrcode': 'ev_token',
            'Remarks': 'ev_remarks',
            'Sms': 'ev_sms',
            'vip(1/0)': 'ev_vip_flag',
            'No reminder(1/0)': 'ev_exclude_email_reminder',
            'Local/Oversea(local/oversea)': 'ev_local_oversea',
            'Private account(yes/no)': 'ev_private_account',
            'Notification(yes/no)': 'ev_notification',
        }
    },
    merchant: {
        dbColMapping: {
            'Username': 'username',
            'Password': 'password',
            'First Name': 'firstname',
            'Last Name': 'lastname',
            'Email': 'email',
            'Mobile': 'mobile',
            'Remarks': 'remarks',
        }
    },
    evoucher: {
        dbColMapping: {
            'Merchant Username': 'merchant_username',
            'Guest Username': 'guest_username',
            'Day': 'day',
            'Location': 'location',
            'isDisabled (0/1)': 'is_disabled',
        }
    },
    reportGeneral: {
        dbColMapping: {
            'Number of ppl': 'guest_count',
            'Number of ppl enabled private account': 'private_ac_count',
            'Number of ppl enabled notification': 'notification_count',
            'Number of ppl deleted account': 'deleted_ac_count',
            'Number of ppl login': 'login_count',
        }
    },
    reportAppAction: {
        dbColMapping: {
            'Map': 'click /Map',
            'Flight + Hotel': 'click /Flight',
            'Dining': 'click /Voucher',
            'Useful Info': 'click /Useinfo',
            'Transport': 'click /Transportation',
            'FAQ': 'click /FAQ',
            'General': 'click /General',
            'Number of ppl using chatroom': 'chatroom_ppl_count',
        }
    },
    reportBusinessMatching: {
        dbColMapping: {
            'Inviter': 'eg_1',
            'Invitee': 'eg_2',
            'Status': 'status',
            'Start Time': 'start_time',
            'End Time': 'end_time',
            'Venue': 'venue',
            'Message': 'message',
            'Remarks': 'remarks',
        },
    },
};

export default config;